export default __webpack_public_path__ + "static/media/group-students-mobile2026.b14f6c7a.png";